import React from 'react';

import { ErrorMessage } from './Animations';
import { cn } from './cn';
import {
  formDescriptionClassName,
  formErrorMessageClassName,
  formLabelClassName,
  formRequiredMarkClassName,
  formSuccessMessageClassName,
} from './formFieldStyles';

export interface FormFieldProps {
  label?: string;
  description?: string;
  errorMessage?: string;
  successMessage?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const FormField = ({
  label,
  description,
  errorMessage,
  successMessage,
  required,
  children,
  className,
  id,
}: FormFieldProps) => {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <label htmlFor={id} className={formLabelClassName}>
          {label}
          {required && <span className={formRequiredMarkClassName}>*</span>}
        </label>
      )}
      {description && <p className={formDescriptionClassName}>{description}</p>}
      {children}
      {errorMessage && <ErrorMessage className={formErrorMessageClassName}>{errorMessage}</ErrorMessage>}
      {successMessage && !errorMessage && (
        <ErrorMessage className={formSuccessMessageClassName}>{successMessage}</ErrorMessage>
      )}
    </div>
  );
};
